import { requestLink } from '@constants/buzzkuri/program-detail'

type Props = {
  id: number
  programId: number
}

export const ProgramRequestOfferFotterBtn = ({
  id,
  programId,
}: Props): JSX.Element => {
  return (
    <a href={requestLink(id, Number(programId))}>
      <div className="flex justify-center items-center md:h-[4.7vw] bg-[#EB8435] rounded-bl-[20px] shadow-30px lg:hover:opacity-50">
        <div className="md:text-[1.3vw] font-bold text-white">
          このプログラムをリクエスト
        </div>
      </div>
    </a>
  )
}
